import styled from "styled-components";
import PulseLoader from "react-spinners/PulseLoader";

const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingText = styled.div`
  font-size: ${({ fontSize }) => fontSize || `16px`};
  font-weight: ${({ fontWeight }) => fontWeight || `600`};
  color: ${({ color }) => color || "#fff"};
`;

const TextLoader = (props) => {
  return (
    <div className="sweet-loading">
      <PulseLoader
        size={props.size || 4}
        color={props.color || "#fff"}
        loading={props.loading}
        style={{ margin: `3px`, paddingTop: `5px`, textAlign: `center` }}
      />
    </div>
  );
};

const ButtonTextLoader = (props) => {
  return (
    <LoaderContainer>
      <LoadingText
        fontSize={props.fontSize || "16px"}
        fontWeight={props.fontWeight || "600"}
        color={props.color || "#fff"}
      >
        {props.loadingText || "Loading"}
      </LoadingText>
      <TextLoader
        size={props.size}
        loading={true}
        color={props.color || "#fff"}
      />
    </LoaderContainer>
  );
};

export default ButtonTextLoader;
